import { Button } from '@finn/design-system/atoms/button';
import { InfoOutlined } from '@finn/design-system/icons/info-outlined';
import {
  BannerModule,
  BannerModuleDescription,
  BannerModuleIcon,
} from '@finn/design-system/modules/BannerModule';
import { App, parseToHtml, useCurrentApp } from '@finn/ui-utils';

export type UnavailabilityBannerProps = {
  type: 'unavailable-banner';
  description: string;
  cta: { label?: string; href?: string };
};

export const UnavailabilityBanner = ({
  description,
  cta,
}: UnavailabilityBannerProps) => {
  const app = useCurrentApp();

  return (
    <BannerModule>
      <BannerModuleIcon>
        <InfoOutlined />
      </BannerModuleIcon>
      <BannerModuleDescription>
        {parseToHtml(description)}
      </BannerModuleDescription>
      <Button
        href={app === App.B2B ? 'tel:+4989143770064' : (cta?.href ?? '')}
        variant="link"
        size="md"
      >
        {cta?.label}
      </Button>
    </BannerModule>
  );
};
